import { createFileRoute } from '@tanstack/react-router';

import { FailedAndRefunded } from '~pages/payments/failed-and-refunded/index';

export const Route = createFileRoute(
  '/_auth/_layout/payment/failed-and-refunded',
)({
  component: FailedAndRefunded,
});
